import $ from '@sparta.global.vendors/jquery';
import '@sparta.global.vendors/lodash';
import spartaBootstrapUtility from '@sparta.global.utilities/sparta-bootstrap-utility/dist/es6.js';
import spartaStoreUtility from '@sparta.global.utilities/sparta-store-utility/dist/es6.js';
import spartaEventsUtility from '@sparta.global.utilities/sparta-events-utility/dist/es6.js';
import spartaTransportUtility from '@sparta.global.utilities/sparta-transport-utility/dist/es6.js';
import spartaGlobalFunctions from '@sparta.global.utilities/sparta-global-functions-utility/dist/es6.js';
import spartaExperienceUtility from '@sparta.global.utilities/sparta-experience-utility/dist/es6.js';
import spartaMessageUtility from '@sparta.global.utilities/sparta-messaging-utility/dist/es6.js';

class Communicator {
  constructor(options) {
    let defaults = {
      public: "document",
      $public: $(),
      private: "",
      $private: $(),
      namespace: "generic"
    };
    this.settings = {};
    this.settings.events = defaults;
    $.extend(this.settings, options);
    this.communication = this.settings.events;
    this.communication.$private = this.settings.$target;
    this.communication.$public = $(this.communication.public);
  }

  // targeting the following code for deprecation.
  // After August release we will delete beacon API from sparta-module-utility
  beacon(action, params) {
    // Wiring up the beacon to work temporarily.
    // Will rewire to use the SpartaEvent pattern.
    //
    let utilities = {
      array: {
        slice: function (array) {
          return Array.prototype.slice.apply(array, Array.prototype.slice.call(arguments, 1));
        },
        remove: function (array, item) {
          var i,
            l = array.length;
          for (i = 0; i < l; i++) {
            if (array[i] === item) {
              array.splice(i, 1);
              i--;
            }
          }
        }
      },
      functional: function (f) {
        var slice = utilities.array.slice,
          prepended = [],
          appended = [],
          boundTo = null,
          before,
          after;
        function wrapper() {
          if (before != null) {
            before.apply(null, arguments);
          }
          var result = f.apply(boundTo, prepended.concat(slice(arguments), appended));
          if (after != null) {
            after.call(null, result);
          }
          return result;
        }
        wrapper.bindTo = function (to) {
          boundTo = to;
          return wrapper;
        };
        wrapper.append = function () {
          appended = slice(arguments);
          return wrapper;
        };
        wrapper.prepend = function () {
          prepended = slice(arguments);
          return wrapper;
        };
        wrapper.before = function (f) {
          before = f;
          return wrapper;
        };
        wrapper.after = function (f) {
          after = f;
          return wrapper;
        };
        return wrapper;
      }
    };
    if (typeof params.context !== "string") return;
    let $location = params.scope === "public" ? this.communication.$public : this.communication.$private;
    if (action === "listen" && typeof params.callback === "function") {
      $location.on(params.context + "." + this.communication.namespace, utilities.functional(params.callback).bindTo(params.caller));
    }
    if (action === "emit") {
      $location.trigger(params.context + "." + this.communication.namespace, [params.data]);
    }
  }
  listen(params) {
    this.beacon("listen", params);
  }
  emit(params) {
    this.beacon("emit", params);
  }
}

class Controller extends Communicator {
  constructor(options) {
    super(options.settings);
    let defaults = {};
    this.settings = defaults;
    $.extend(this.settings, options.settings);
    this.model = options.model;
  }
}

class Model extends Communicator {
  constructor(options) {
    super(options.settings);
    var defaults = {};
    this.settings = defaults;
    $.extend(this.settings, options.settings);
    this.protected = [];
    this._initialize();
  }
  get data() {
    return this.protected;
  }
  set data(value) {
    this.protected = value;
  }
  _initialize() {
    // Model initialization code here.
  }
}

class View extends Communicator {
  constructor(options) {
    super(options.settings);
    let defaults = {};
    this.settings = defaults;
    this.settings = $.extend(defaults, options.settings);
    this.model = options.model;
    this._initialize();
  }
  _initialize() {
    // View initialization code here.
  }
}

// Third party imports

function registerModuleClass({
  moduleClass,
  moduleConfig
}) {
  spartaBootstrapUtility.registerModuleClass({
    moduleClass,
    moduleConfig
  });
}
class Module {
  constructor(options) {
    if (options && Object.keys(options).length) {
      const defaults = {
        target: null,
        $target: $(),
        debug: false,
        events: {
          namespace: "module"
        }
      };
      this.settings = {
        ...defaults,
        ...options
      };
      this.settings.target = this.settings.class || this.settings.target;
      this.settings.$target = $(this.settings.target); // How can we get rid of $target? If we dont then we will never be able to get rid of jQuery
      this.settings.SPARTA_READY = this.settings.$target.data("sparta-load") === "primary" ? "SPARTA_GLOBAL_READY.spartaBootstrapUtility" : "SPARTA_SECONDARY_READY.spartaBootstrapUtility";

      /*  Gather all appropriate data attributes associated with this module.
          These can then be accessed as overrides on default actions/behaviors/values.
      */
      for (const data in this.settings.data) {
        if (this.settings.$target.data(data)) {
          this.settings.data[data] = this.settings.$target.data(data);
        }
      }
      this.model = new Model({
        settings: this.settings
      });
      this.view = new View({
        model: this.model,
        settings: this.settings
      });
      this.controller = new Controller({
        model: this.model,
        settings: this.settings
      });
      this.Events = spartaEventsUtility;
      this.Store = spartaStoreUtility;
      this.Transport = spartaTransportUtility;
      this.SpartaFunctions = spartaGlobalFunctions;
      this.Experience = spartaExperienceUtility;
      this.Message = spartaMessageUtility;
      this.isWidget = !!spartaStoreUtility.getData("isWidget");
      if (this.isWidget) {
        this.widgetInfo = options.widgetInfo;
      }
      this.applicationContext = spartaStoreUtility.getData("applicationContext", this.widgetInfo);
      this.applicationContainer = spartaStoreUtility.getData("applicationContainer", this.widgetInfo);
      this.spaParams = spartaStoreUtility.getData("spaParams");
      this.eventDelegatorString = this.applicationContext ? `#${this.applicationContext.id}` : "[data-sparta-container]";
      this.params = this.settings.$target.data("module-parameters");
      this.vuex = options.vuex;
      this.vuexStore = options.vuexStore;

      // sets module info (name/version/options)
      this.settings.moduleInfo = {
        name: this.settings.$target.data("module"),
        version: this.settings.$target.data("version")
      };

      // options are set on applicationContainer in 'data-sparta-overrides' via Bootstrap-utility
      this.settings.moduleInfo.options = this.Store.getData("applicationOptions", this.widgetInfo)[this.settings.moduleInfo.name];
      if (!options.doNotRegister) {
        spartaBootstrapUtility.register(this);
      }
    }
  }
  async mountAll(modules, widgetInfo) {
    await spartaBootstrapUtility.mountAll(modules, widgetInfo);
  }
  onError(errors = []) {
    console.error(`Module could not be loaded:\n${errors.map(err => err.errorMessage).join('\n') || 'Unknown error'}`);
  }
}

export { Module as default, registerModuleClass };
